import { Injectable, ChangeDetectorRef } from '@angular/core';
import { SecretService } from '../../../_core/services/secret.service';

@Injectable()
export class GridSetupModalService {

    private matTableRef;
    private cdr: ChangeDetectorRef;
    private resized = false;
    private storageColumnsKey = '';
    private storageOrderModeKey = '';
    private initialColumns = [];

    constructor(private secretService: SecretService) { }

    public setAvailableColumns(columns, locked) {
        this.resized = false;
        const allColumns = [...locked, ...columns];
        localStorage.setItem(this.storageOrderModeKey, this.getCreationCurrentMode());
        localStorage.setItem(this.storageColumnsKey, JSON.stringify(allColumns));
    }

    public getAvailableColumns() {
        const mode = localStorage.getItem(this.storageOrderModeKey);
        if (mode === this.getCreationCurrentMode()) {
            return JSON.parse(localStorage.getItem(this.storageColumnsKey));
        } else {
            localStorage.removeItem(this.storageOrderModeKey);
            return null;
        }
    }

    private getCreationCurrentMode() {
        const settings: any = this.secretService.getPortalSettings();
        return settings ? settings.sOrderLogic : null;
    }

    public isColumnLocked(column) {
        if (this.getAvailableColumns()) {
            const col = this.getAvailableColumns().find(c => c.column === column);
            return col ? !!col.locked : false;
        } else {
            return false;
        }
    }

    public setDefaultResize() {
        this.matTableRef = undefined;
        this.cdr = undefined;
        this.resized = false;
    }

    public setInitialColumns(columns) {
        this.initialColumns = columns;
    }

    public isResized() {
        if (!this.resized && !!this.matTableRef) {
            this.resizeColumns();
        }
    }

    public resizeColumns() {
        this.resized = true;
        this.cdr.detectChanges();
        this.matTableRef.updateStickyColumnStyles();
    }

    public isLastLocked(column) {
        const col = this.getAvailableColumns() ? this.getAvailableColumns() : [];
        const locked = col.filter(c => !!c.locked);
        if (!!locked && locked.length > 0) {
            return locked[locked.length - 1].column === column;
        } else {
            return false;
        }
    }

    public setMatTableRef(matTableRef, cdr, viewName) {
        if (!this.matTableRef && !!matTableRef) {
            this.cdr = cdr;
            this.matTableRef = matTableRef;
            this.storageColumnsKey = `availableColumns_${viewName}`;
            this.storageOrderModeKey = `orderMode_${viewName}`;
        }
    }

    public getColumnSet() {
        if (this.getAvailableColumns()) {
            const columns = this.getAvailableColumns().filter(c => !!c.active);
            return columns.map(c => c.column);
        } else {
            return this.initialColumns;
        }
    }

}
